/**
 * Textos (en) de planta — OBR-87: recepció sense comanda prèvia: namespace `planta.receptionDirect`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts) i les mateixes
 * variables. Vocabulari del sector: «Existències», mai «Stock».
 */

export const receptionDirectEn = {
  'planta.receptionDirect': {
    // ── Permission: who may receive without an order (admin, purchasing, operator: what the server lets be written) ──
    noPermission:
      'Only administration, purchasing and operators can record a reception without an order.',

    // ── Supplier: the one hard requirement (the list is on the device: picking one needs no connection) ──
    supplierRequired: 'Pick the supplier before confirming the reception.',
    supplierFirstHint: 'Pick the supplier first: only its articles are offered.',
    supplierChange: 'Change',

    // ── Supplier: hard, but never mute (what to do in each case), search, and a change that loses nothing silently ──
    suppliersNoneOnDevice:
      'This device has no suppliers. Connect and sync to download the suppliers.',
    supplierNotListedHint:
      'If the supplier is not there, ask Purchasing to add it in the BackOffice.',
    supplierSearch: 'Search for a supplier',
    supplierSearchNoMatch: 'No supplier matches the search.',
    supplierChangeTitle: 'Change to {{supplier}}?',
    supplierChangeLoses_one: '{{count}} line of this delivery note will be lost.',
    supplierChangeLoses_other: 'The {{count}} lines of this delivery note will be lost.',
    supplierChangeKeep: 'Do not change',
    supplierChangeConfirm: 'Change and remove the lines',

    // ── Supplier lot: required, with a way out (never stuck) ──
    lotMissing: 'The supplier lot of this entry is missing.',
    lotMissingSummary_one:
      'The supplier lot of {{count}} entry is missing. Type it in or confirm without a lot.',
    lotMissingSummary_other:
      'The supplier lot of {{count}} entries is missing. Type them in or confirm without a lot.',
    lotAndExpiryMissingSummary:
      'The supplier lot and the expiry date of some entries are missing. Fill them in or confirm anyway.',
    confirmWithoutLot: 'Confirm without supplier lot',
    confirmWithoutLotHint:
      'If you do not know it, you can confirm anyway: the goods come in with the internal lot, but without the supplier lot. It will be noted in the activity log.',
    confirmWithoutBoth: 'Confirm without lot or expiry',
    confirmWithoutBothHint:
      'If you do not know them, you can confirm anyway: the goods come in with the internal lot, without the supplier lot or the expiry date. The stock is listed under “To regularize” until an expiry date is added. It will be noted in the activity log.',

    // ── Article picker: the way out when the supplier has none linked ──
    pickerShowAll: 'Show all articles',
    pickerShowSupplierOnly: 'Only this supplier’s articles',
  },
} as const;
